// extracted by mini-css-extract-plugin
module.exports = {"disc":"gS4HP"};